<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import draggable from 'vuedraggable'
import Multiselect from "vue-multiselect";
import axios from "axios";
import moment from "moment";
import { VMoney } from 'v-money'
import Swal from "sweetalert2";

import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";


/**
 * Advanced table component
 */
export default {
  name: "JobForm",
  page: {
    title: "Buat Job",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker, draggable, Multiselect },
  directives: {
    money: VMoney
  },
  data() {
    return {
      title: "Buat Job",
      items: [
        {
          text: "Manajemen Job",
          href: "/job"
        },
        {
          text: "Buat Job",
          active: true
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        precision: 0,
      },
      step: 1,
      pickup: {
        address: "",
        address_detail: "",
        name: "",
        phone_number: "",
        lat: "",
        lng: "",
      },
      dropoff: {
        address: "",
        address_detail: "",
        name: "",
        phone_number: "",
        lat: "",
        lng: "",
      },
      listAddress: [],
      statusPublish: null,
      form: {
        pickupDate: null,
        estimationDate: null,
        weight: "",
        volume: "",
        koli: "",
        note: "",
        asuransi: null,
        driverType: null,
        pic_name: "",
        pic_phone: "",
        driver: null,
        armada: null,
        offer_lower_limit: "",
        offer_upper_limit: "",
        package: []
      },
      packageList: [],
      asuransiList: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak (Segala kerusakan menjadi tanggung jawab LC)'}
      ],
      driverTypeList: [
        { value: 'internal', text: 'Internal Driver' },
        { value: 'external', text: 'Public Driver'}
      ],
      armadaCategories: [],
      selectedCategory: {},
      isSubmitJobError: false,
      errorMessage: null,
      isSubmitJobSuccess: false,
      successMessage: null,
      isLoadingSearchAddress: false,
      addresses: [],
      mapCenter: {
        lat: -6.914864,
        lng: 107.608238
      },
      driverList: [],
      armadaList: [],
      isValidAddress: false
    };
  },
  validations() {
    const maxOffer = this.convertToAngka(this.form.offer_upper_limit)
    const maxVal = (value) => this.convertToAngka(value) <= maxOffer
    return {
      form: {
        pickupDate: {
          required,
          minDate: value => moment(value).add(1, 'days').isAfter(moment())
        },
        estimationDate: {
          required,
          minDate: value => moment(value).add(1, 'days').isAfter(moment())
        },
        package: { required },
        weight: { required },
        volume: { required },
        koli: { required },
        note: { required },
        asuransi: { required },
        driverType: { required },
        pic_name: { required },
        pic_phone: { required, minLength: minLength(8), maxLength: maxLength(15) },
        driver: {
          required: requiredIf(function () {
              return this.$route.name === 'JobEdit' && this.form.driverType === 'internal'
            }
          ),
        },
        armada: {
          required: requiredIf(function () {
              return this.$route.name === 'JobEdit' && this.form.driverType === 'internal'
            }
          ),
        },
        offer_lower_limit: { maxVal },
      },
      pickup: {
        address: { required },
        address_detail: { required },
        name: { required },
        phone_number: { required, minLength: minLength(8), maxLength: maxLength(15) },
      },
      dropoff: {
        address: { required },
        address_detail: { required },
        name: { required },
        phone_number: { required, minLength: minLength(8), maxLength: maxLength(15) },
      }
    }
  },
  async created() {
    await this.getArmadaCategory()
    this.getPackage()
    this.getDriver()
    this.getArmada()
    if (this.$route.name === 'JobEdit') {
      this.getDetailJob()
    }
  },
  computed: {
    canNextStep() {
      const pickup = this.listAddress.filter(item => item.type === 'pickup')
      const dropoff = this.listAddress.filter(item => item.type === 'dropoff')
      return pickup.length > 0 && dropoff.length > 0
    },
    invalidMinimalOffer() {
      let invalid = false
      if (this.form.offer_lower_limit !== "0" || this.form.offer_upper_limit !== "0") {
        const min = this.convertToAngka(this.form.offer_lower_limit)
        const max = this.convertToAngka(this.form.offer_upper_limit)
        if (min > max) {
          invalid = true
        }
      }
      return invalid
    }
  },
  mounted() {
    this.handlePermission()
  },
  methods: {
    getDetailJob() {
      this.$axios.get(`/v1/logistic_company/job/${this.$route.params.id}`)
        .then(response => {
          const job = response.data.data
          let pacakges = []
          if (job.packages !== undefined) {
            for (let index = 0; index < job.packages.length; index++) {
              const item = job.packages[index];
              pacakges.push(item.package)
            }
          }
          this.form = {
            pickupDate: moment.utc(job.start_date).format('YYYY-MM-DD HH:mm:ss'),
            estimationDate: moment.utc(job.end_date).format('YYYY-MM-DD HH:mm:ss'),
            weight: job.package_weight,
            volume: job.package_volume,
            koli: job.package_koli,
            note: job.package_note,
            asuransi: job.status_insurance,
            driverType: job.type,
            pic_name: job.pic_name,
            pic_phone: job.pic_phone,
            driver: job.driver,
            armada: job.armada,
            offer_lower_limit: job.offer_lower_limit !== null ? this.convertToRupiah(job.offer_lower_limit) : "",
            offer_upper_limit: job.offer_upper_limit !== null ? this.convertToRupiah(job.offer_upper_limit) : "",
            package: pacakges
          }
          this.statusPublish = job.status_publish
          this.listAddress = job.addresses.map(item => {
            return {
              address: {
                formatted_address: item.address
              },
              address_detail: item.address_detail,
              name: item.name,
              phone_number: item.phone_number,
              lat: Number(item.lat),
              lng: Number(item.lng),
              type: item.type,
            }
          })
          const indexCategory = this.armadaCategories.findIndex(item => item.id === job.armada_category_id)
          console.log(indexCategory)
          this.$refs.slider.goTo(indexCategory)
          this.$v.$touch();
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.$router.push('/404')
          }
        })
    },
    async getArmadaCategory() {
      await this.$axios.get('/v1/armada_category', {
        params: {
          page: 1,
          per_page: 100,
          orderby: 'name',
          sort: 'asc',
          status: 'aktif'
        }
      })
        .then(response => {
          this.armadaCategories = response.data.data.rows
          this.selectedCategory = response.data.data.rows[0]
          setTimeout(() => {
            if (this.$route.query.armada) {
              const indexCategory = this.armadaCategories.findIndex(item => item.id === Number(this.$route.query.armada))
              this.$refs.slider.goTo(indexCategory)
            }
          }, 500)
        })
    },
    getPackage() {
      this.$axios.get('/v1/package', {
        params: {
          page: 1,
          per_page: 100,
          orderby: 'name',
          sort: 'asc',
          status: 'aktif'
        }
      })
        .then(response => {
          this.packageList = response.data.data.rows
        })
    },
    armadaSlided(index) {
      this.selectedCategory = this.armadaCategories[index]
      this.getArmada()
    },
    submitPickupAddress () {
      this.$v.$touch();
      if (!this.$v.pickup.$invalid) {
        if (this.pickup.index !== undefined) {
          this.listAddress[this.pickup.index] = {
            address: this.pickup.address,
            address_detail: this.pickup.address_detail,
            name: this.pickup.name,
            phone_number: this.pickup.phone_number,
            lat: this.pickup.lat,
            lng: this.pickup.lng,
            type: 'pickup',
          }
        } else {
          this.listAddress.push({
            ...this.pickup,
            type: 'pickup',
          })
        }
      
        this.$refs.modalPickup.hide();
        this.pickup = {
          address: "",
          address_detail: "",
          name: "",
          phone_number: "",
          lat: "",
          lng: "",
        }
        this.updateMapBound()
        this.$v.$reset();
      }
    },
    submitDropoffAddress () {
      this.$v.$touch();
      if (!this.$v.dropoff.$invalid) {
        if (this.dropoff.index !== undefined) {
          this.listAddress[this.dropoff.index] = {
            address: this.dropoff.address,
            address_detail: this.dropoff.address_detail,
            name: this.dropoff.name,
            phone_number: this.dropoff.phone_number,
            lat: this.dropoff.lat,
            lng: this.dropoff.lng,
            type: 'dropoff',
          }
        } else {
          this.listAddress.push({
            ...this.dropoff,
            type: 'dropoff',
          })
        }
        this.$refs.modalDropoff.hide();
        this.dropoff = {
          address: "",
          address_detail: "",
          name: "",
          phone_number: "",
          lat: "",
          lng: "",
        }
        this.updateMapBound()
        this.$v.$reset();
      }
    },
    updateMapBound() {
      //set bounds of the map
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line no-undef
        const bounds = new google.maps.LatLngBounds()
        for (let m of this.listAddress) {
          bounds.extend({
            lat: m.lat, 
            lng: m.lng
          })
        }
        map.fitBounds(bounds);
      });
    },
    deleteAddress(index) {
      this.listAddress.splice(index, 1);
      
    },
    editAddress(address, index) {
      if (address.type === 'pickup') {
        this.pickup = {
          ...address,
          index
        };
        this.$refs.modalPickup.show();
      } else {
        this.dropoff = {
          ...address,
          index
        };
        this.$refs.modalDropoff.show();
      }
    },
    handlePermission() {
      navigator.permissions.query({ name: 'geolocation' })
        .then((result) => {
          console.log(result);
        });
      navigator.geolocation.getCurrentPosition((position) => {
        this.mapCenter = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      });
    },
    setIconMarker(type) {
      return type == 'dropoff' ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    },
    nextForm() {
      const isFirstAddressPickupPoint = this.listAddress[0].type === 'pickup'
      const isLastAddressDropoffPoint = this.listAddress[this.listAddress.length - 1].type === 'dropoff'
      if (isFirstAddressPickupPoint && isLastAddressDropoffPoint) {
        this.step = 2
        this.isValidAddress = false
      } else {
        this.step = 1
        this.isValidAddress = true
      }
    },
    submitForm(status) {
      this.statusPublish = status;
      this.$refs.submit.click()
    },
    submitCreateJob() {
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        // hit API submit here
        const addresses = this.listAddress.map(item => {
          return {
            ...item,
            address: item.address.formatted_address
          }
        })
        const payload = {
          armada_category_id: this.selectedCategory.id,
          addresses: addresses,
          start_date: this.form.pickupDate,
          end_date: this.form.estimationDate,
          package_weight: this.form.weight,
          package_volume: this.form.volume,
          package_koli: this.form.koli,
          package_note: this.form.note,
          status_insurance: this.form.asuransi,
          type: this.form.driverType,
          driver_id: this.form.driver ? this.form.driver.id : null,
          armada_id: this.form.armada ? this.form.armada.id : null,
          pic_name: this.form.pic_name,
          pic_phone: this.form.pic_phone,
          status_publish: this.statusPublish,
          offer_lower_limit: this.convertToAngka(this.form.offer_lower_limit),
          offer_upper_limit: this.convertToAngka(this.form.offer_upper_limit),
          packages: this.form.package.map(item => {
            return {
              id: item.id
            }
          })
        }

        window.scrollTo(0,0);

        let requestConfig = {}
        if (this.$route.name === 'JobCreate') {
          requestConfig = {
            method: 'POST',
            url: '/v1/logistic_company/job',
            data: payload
          }
        } else {
          requestConfig = {
            method: 'PUT',
            url: `/v1/logistic_company/job/${this.$route.params.id}`,
            data: payload
          }
        }

        this.$axios(requestConfig)
          .then(response => {
            this.isSubmitJobSuccess = true
            this.isSubmitJobError = false
            this.successMessage = response.data.message
            setTimeout(() => {
              if (this.$route.name === 'JobCreate') {
                this.$router.push('/job')
              } else {
                if (this.statusPublish === 'draft') {
                  this.$router.push('/job')
                } else {
                  this.$router.push(`/job/${this.$route.params.id}`)
                }
              }
            }, 3000)
          }).catch(error => {
            this.isSubmitJobSuccess = false
            this.isSubmitJobError = true
            this.errorMessage = error.response.data.message
          })
      }
    },
    searchAddress(search) {
      this.isLoadingSearchAddress = true
      axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
          address: search
        }
      })
      .then((response) => {
        this.isLoadingSearchAddress = false
        this.addresses = response.data.results
      })
      .catch(err => { 
        //handle errors 
        this.isLoadingSearchAddress = false
        console.log(err)
      })
    },
    choosePickup(address) {
      this.pickup.lat = address.geometry.location.lat
      this.pickup.lng = address.geometry.location.lng
    },
    chooseDropoff(address) {
      this.dropoff.lat = address.geometry.location.lat
      this.dropoff.lng = address.geometry.location.lng
    },
    getDriver(search) {
      this.isLoadingSearchDriver = true
        this.$axios.get('/v1/logistic_company/driver', {
          params: {
            page: 1,
            per_page: 25,
            key: search,
            orderby: 'name',
            sort: 'asc',
            account_status: 'aktif',
            availability_status: 'tersedia',
          }
        })
        .then((response) => {
          this.driverList = response.data.data.rows
        })
    },
    getArmada(search) {
      this.isLoadingSearchArmada = true
        this.$axios.get('/v1/logistic_company/armada', {
          params: {
            page: 1,
            per_page: 25,
            key: search,
            orderby: 'merk',
            sort: 'asc',
            status: 'aktif',
            availability_status: 'tersedia',
            vehicle_category_id: this.selectedCategory.id
          }
        })
        .then((response) => {
          this.armadaList = response.data.data.rows
        })
    },
    minDate(date) {
      if (this.form.pickupDate === null) {
        return moment(date).isSameOrBefore(moment().subtract(1, 'day'))
      } else {
        return moment(date).isSameOrBefore(moment(this.form.pickupDate, 'YYYY-MM-DD HH:mm:ss').subtract(1, 'day'));
      }
    },
    deleteJob() {
      Swal.fire({
        title: "Apakah Anda yakin ingin menghapus Job ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then(result => {
        if (result.value) {
          window.scrollTo(0,0);
          this.$axios.delete(`/v1/logistic_company/job/${this.$route.params.id}`)
            .then(response => {
              this.isSubmitJobSuccess = true
              this.isSubmitJobError = false
              this.successMessage = response.data.message
              setTimeout(() => {
                this.$router.push('/job')
              }, 1500)
            }).catch(error => {
              this.isSubmitJobSuccess = false
              this.isSubmitJobError = true
              this.errorMessage = error.response.data.message
            })
        }
      });
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="isSubmitJobSuccess"
              class="mt-3"
              variant="success"
              dismissible
            >{{ successMessage }}</b-alert>

            <b-alert
              v-model="isSubmitJobError"
              class="mt-3"
              variant="danger"
              dismissible
            >{{errorMessage}}</b-alert>
            <div class="row">
              <div class="col-lg-6">
                <div id="rute" v-show="step === 1">
                  <p class="font-size-18 font-weight-bold">
                    Pilih Kategori
                  </p>
                  <div v-if="armadaCategories.length > 0" class="content-slider border-radius d-flex justify-content-center p-2 mb-4">
                    <i class="fas fa-arrow-alt-circle-left font-size-24 nav-kiri" @click="$refs.slider.prev()"></i>
                    <VueSlickCarousel ref="slider" class="w-75" @afterChange="armadaSlided" :accessibility="true" :arrows="true" :infinite="true" :slidesToShow="1">
                      <div v-for="(category, index) in armadaCategories" :key="index" class="text-center p-2 list-armada">
                        <img :src="category.photo" alt="200x200" class="img-thumbnail w-100 armada" />
                        <p class="font-weight-bolder mt-2">
                          {{ category.name }}
                        </p>
                      </div>
                    </VueSlickCarousel>
                    <i class="fas fa-arrow-alt-circle-right font-size-24 nav-kanan" @click="$refs.slider.next()"></i>
                  </div>
                  <p class="font-size-18 font-weight-bold">
                    Rute
                  </p>
                  <draggable
                    id="list-address"
                    class="p-3 rounded"
                    v-model="listAddress"
                  >
                    <transition-group>
                      <b-card
                        no-body
                        v-for="(item, index) in listAddress"
                        :key="JSON.stringify(item)"
                        class="mb-2 border"
                      >
                        <div class="p-2">
                          <div class="action float-right">
                            <i @click="editAddress(item, index)" class="mdi mdi-pencil-outline edit font-size-24 mr-1 cursor-pointer border border-dark rounded"></i>
                            <i @click="deleteAddress(index)" class="mdi mdi-trash-can-outline delete font-size-24 ml-1 cursor-pointer border border-dark rounded"></i>
                          </div>
                          <h6>
                            {{ item.name }}
                            <span class="text-danger" v-if="item.type === 'pickup'">(Pickup)</span>
                            <span class="text-success" v-if="item.type === 'dropoff'">(Dropoff)</span>
                          </h6>
                          <p class="mb-1">
                            {{ item.address.formatted_address }} <br />
                            {{ item.address_detail }}, {{ item.phone_number }}
                          </p>
                        </div>
                      </b-card>
                    </transition-group>
                  </draggable>
                  <div class="d-inline-flex align-item-start">
                    <b-button type="button" variant="danger" class="m-1" @click="$refs.modalPickup.show();">Tambah Pickup</b-button>
                    <b-button type="button" variant="success" class="m-1" @click="$refs.modalDropoff.show();">Tambah Dropoff</b-button>
                  </div>
                  <b-alert
                    v-model="isValidAddress"
                    class="my-3"
                    variant="danger"
                    dismissible
                  >
                    Alamat pertama harus pickup dan alamat terakhir harus dropoff
                  </b-alert>
                  <b-button type="button" class="w-100 mt-3" variant="danger" @click="nextForm" :disabled="!canNextStep">Selanjutnya</b-button>
                </div>
                <div id="detail" v-show="step === 2">
                  <form ref="formJob" @submit.prevent="submitCreateJob">
                  <button ref="submit" type="submit" style="display:none;">Submit</button>
                    <div class="form-group row">
                      <div class="col-sm-6">
                        <div class="form-group mb-3">
                          <label>Tanggal Pickup</label>
                          <date-picker
                            id="pickup-date"
                            name="pickupDate"
                            :class="{ 'is-invalid': $v.form.pickupDate.$error }"
                            v-model="form.pickupDate"
                            type="datetime"
                            :first-day-of-week="1"
                            format="DD MMMM YYYY HH:mm"
                            value-type="YYYY-MM-DD HH:mm:ss"
                            :minute-step="15"
                            :disabled-date="notBeforeToday"
                          ></date-picker>
                          <div v-if="$v.form.pickupDate.$error" class="invalid-feedback">
                            <span v-if="!$v.form.pickupDate.required">{{ $t('form.validation.required', { field: 'Tanggal Pickup' }) }}</span>
                            <span v-if="!$v.form.pickupDate.minDate">{{ $t('form.validation.min_value', { field: 'Tanggal Pickup', label: 'Hari ini' }) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group mb-3">
                          <label>Estimasi Sampai</label>
                          <date-picker
                            id="estimation-date"
                            name="estimationDate"
                            :class="{ 'is-invalid': $v.form.estimationDate.$error }"
                            v-model="form.estimationDate"
                            type="datetime"
                            :first-day-of-week="1"
                            format="DD MMMM YYYY HH:mm"
                            value-type="YYYY-MM-DD HH:mm:ss"
                            :minute-step="15"
                            :disabled-date="minDate"
                          ></date-picker>
                          <div v-if="$v.form.estimationDate.$error" class="invalid-feedback">
                            <span v-if="!$v.form.estimationDate.required">{{ $t('form.validation.required', { field: 'Tanggal Sampai' }) }}</span>
                            <span v-if="!$v.form.estimationDate.minDate">{{ $t('form.validation.min_value', { field: 'Tanggal Sampai', label: 'Tanggal Pickup' }) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5>Detail Paket</h5>
                    <b-form-group id="package-group" label="Kategori Barang" label-for="package">
                      <multiselect v-model="form.package" id="package" 
                        label="name" 
                        track-by="id" 
                        placeholder="" 
                        open-direction="bottom" 
                        :options="packageList" 
                        :multiple="true" 
                        :searchable="true" 
                        :internal-search="true" 
                        :clear-on-select="false" 
                        :close-on-select="true"
                        :max-height="600" 
                        :show-no-results="false" 
                        :hide-selected="true" 
                        :class="{ 'is-invalid': $v.form.package.$error }"
                      >
                        <template slot="noOptions">Package Tidak ditemukan</template>
                      </multiselect>
                      <div v-if="$v.form.package.$error" class="invalid-feedback">
                        <span v-if="!$v.form.package.required">{{ $t('form.validation.required', { field: 'Kategori Barang' }) }}</span>
                      </div>
                    </b-form-group>
                    <div class="form-group row">
                      <div class="col-sm-4">
                        <div class="form-group mb-3">
                          <b-form-group id="weight-group" label="Weight (Kg)" label-for="weight">
                            <b-form-input
                              id="weight"
                              name="weight"
                              v-model="form.weight"
                              :class="{ 'is-invalid': $v.form.weight.$error }"
                              type="text"
                            ></b-form-input>
                            <div v-if="$v.form.weight.$error" class="invalid-feedback">
                              <span v-if="!$v.form.weight.required">{{ $t('form.validation.required', { field: 'Weight' }) }}</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group mb-3">
                        <b-form-group id="volume-group" label="Volume (m3)" label-for="volume">
                            <b-form-input
                              id="volume"
                              name="colume"
                              v-model="form.volume"
                              :class="{ 'is-invalid': $v.form.volume.$error }"
                              type="text"
                            ></b-form-input>
                            <div v-if="$v.form.volume.$error" class="invalid-feedback">
                              <span v-if="!$v.form.volume.required">{{ $t('form.validation.required', { field: 'Volume' }) }}</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group mb-3">
                        <b-form-group id="koli-group" label="Koli (Pcs)" label-for="koli">
                            <b-form-input
                              id="koli"
                              name="koli"
                              v-model="form.koli"
                              :class="{ 'is-invalid': $v.form.koli.$error }"
                              type="text"
                            ></b-form-input>
                            <div v-if="$v.form.koli.$error" class="invalid-feedback">
                              <span v-if="!$v.form.koli.required">{{ $t('form.validation.required', { field: 'Koli' }) }}</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <h5>Estimasi Penawaran (Optional)</h5>
                    <div class="form-group row">
                      <div class="col-sm-6">
                        <div class="form-group mb-3">
                          <b-form-group id="offer_lower_limit-group" label="Penawaran Minimal" label-for="offer_lower_limit">
                            <b-form-input
                              id="offer_lower_limit"
                              name="offer_lower_limit"
                              v-model="form.offer_lower_limit"
                              :class="{ 'is-invalid': $v.form.offer_lower_limit.$error || invalidMinimalOffer }"
                              type="text"
                              v-money="money"
                            ></b-form-input>
                            <div v-if="$v.form.offer_lower_limit.$error || invalidMinimalOffer" class="invalid-feedback">
                              <span>Penawaran Minimal tidak boleh melebihi Penawaran Maksimal</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group mb-3">
                        <b-form-group id="offer_upper_limit-group" label="Penawaran Maksimal" label-for="offer_upper_limit">
                            <b-form-input
                              id="offer_upper_limit"
                              name="offer_upper_limit"
                              v-model="form.offer_upper_limit"
                              type="text"
                              v-money="money"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <b-form-group id="note-group" label="Note" label-for="note">
                      <b-textarea
                        id="note"
                        name="note"
                        v-model="form.note"
                        :class="{ 'is-invalid': $v.form.note.$error }"
                        rows="5"
                      ></b-textarea>
                      <div v-if="$v.form.note.$error" class="invalid-feedback">
                        <span v-if="!$v.form.note.required">{{ $t('form.validation.required', { field: 'Note' }) }}</span>
                      </div>
                    </b-form-group>
                    <b-form-group label="Asuransi" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="asuransi"
                        name="asuransi"
                        v-model="form.asuransi"
                        :options="asuransiList"
                        :aria-describedby="ariaDescribedby"
                        :class="{ 'is-invalid': $v.form.asuransi.$error }"
                      ></b-form-radio-group>
                      <div v-if="$v.form.asuransi.$error" class="invalid-feedback">
                        <span v-if="!$v.form.asuransi.required">{{ $t('form.validation.required', { field: 'Asuransi' }) }}</span>
                      </div>
                    </b-form-group>
                    <h5>Assign Job Kepada</h5>
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="driverType"
                        name="driverType"
                        v-model="form.driverType"
                        :options="driverTypeList"
                        :aria-describedby="ariaDescribedby"
                        :class="{ 'is-invalid': $v.form.driverType.$error }"
                      ></b-form-radio-group>
                      <div v-if="$v.form.driverType.$error" class="invalid-feedback">
                        <span v-if="!$v.form.driverType.required">{{ $t('form.validation.required', { field: 'Job Assign' }) }}</span>
                      </div>
                    </b-form-group>
                    <template v-if="form.driverType === 'internal'">
                      <b-form-group id="driver-group" label="Driver" label-for="driver">
                        <multiselect v-model="form.driver" id="driver" 
                          label="name" 
                          track-by="id" 
                          placeholder="Ketik untuk mencari nama driver" 
                          open-direction="bottom" 
                          :options="driverList" 
                          :multiple="false" 
                          :searchable="true" 
                          :internal-search="true" 
                          :clear-on-select="false" 
                          :close-on-select="true"
                          :max-height="600" 
                          :show-no-results="false" 
                          :hide-selected="true" 
                          :class="{ 'is-invalid': $v.form.driver.$error }"
                        >
                          <template slot="noOptions">Driver tidak ditemukan, coba kata kunci lain</template>
                        </multiselect>
                        <div v-if="$v.form.driver.$error" class="invalid-feedback">
                          <span v-if="!$v.form.driver.required">{{ $t('form.validation.required', { field: 'Driver' }) }}</span>
                        </div>
                      </b-form-group>
                      <b-form-group id="armada-group" label="Armada" label-for="armada">
                        <multiselect v-model="form.armada" id="armada"
                          label="merk" 
                          track-by="id" 
                          placeholder="Ketik merk / plat nomor untuk mencari armada" 
                          open-direction="bottom" 
                          :options="armadaList" 
                          :multiple="false" 
                          :searchable="true" 
                          :internal-search="true" 
                          :clear-on-select="false" 
                          :close-on-select="true"
                          :max-height="600" 
                          :show-no-results="false" 
                          :hide-selected="true" 
                          :class="{ 'is-invalid': $v.form.armada.$error }"
                        >
                          <template slot="noOptions">Armada tidak ditemukan, coba kata kunci lain</template>
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.merk }}, {{ option.plat_number }}
                          </template>
                          <template slot="option" slot-scope="{ option }">
                            {{ option.merk }}, {{ option.plat_number }}
                          </template>
                        </multiselect>
                        <div v-if="$v.form.armada.$error" class="invalid-feedback">
                          <span v-if="!$v.form.armada.required">{{ $t('form.validation.required', { field: 'Armada' }) }}</span>
                        </div>
                      </b-form-group>
                    </template>
                    <h5>Info PIC</h5>
                    <div class="form-group row mb-0">
                      <div class="col-sm-6">
                        <b-form-group id="pic_name-group" label="Nama" label-for="pic_name">
                          <b-form-input
                            id="pic_name"
                            name="pic_name"
                            v-model="form.pic_name"
                            :class="{ 'is-invalid': $v.form.pic_name.$error }"
                            type="text"
                          ></b-form-input>
                          <div v-if="$v.form.pic_name.$error" class="invalid-feedback">
                        <span v-if="!$v.form.pic_name.required">{{ $t('form.validation.required', { field: 'Nama PIC' }) }}</span>
                      </div>
                        </b-form-group>
                      </div>
                      <div class="col-sm-6">
                        <b-form-group id="pic_phone-group" label="Telepon" label-for="pic_phone">
                          <b-form-input
                            id="pic_phone"
                            name="pic_phone"
                            v-model="form.pic_phone"
                            :class="{ 'is-invalid': $v.form.pic_phone.$error }"
                            type="text"
                          ></b-form-input>
                          <div v-if="$v.form.pic_phone.$error" class="invalid-feedback">
                            <span v-if="!$v.form.pic_phone.required">{{ $t('form.validation.required', { field: 'Telepon' }) }}</span>
                            <span v-if="!$v.form.pic_phone.minLength">{{ $t('form.validation.min_length', { field: 'Telepon', length: 8 }) }}</span>
                            <span v-if="!$v.form.pic_phone.maxLength">{{ $t('form.validation.max_length', { field: 'Telepon', length: 15 }) }}</span>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <div class="col-sm-3">
                        <b-button class="w-100 btn-light" type="button" @click="step = 1">Kembali</b-button>
                      </div>
                      <div class="col-sm-5">
                        <b-button variant="warning" class="w-100" type="button" @click="submitForm('draft')">Simpan Sebagai Draft</b-button>
                      </div>
                      <div class="col-sm-4">
                        <b-button variant="danger" class="w-100" type="button" @click="submitForm('published')">Publish Job</b-button>
                      </div>
                    </div>
                    <div class="form-group row mt-3" v-if="statusPublish === 'draft' && $route.name === 'JobEdit'">
                      <div class="col-sm-12">
                        <b-button variant="outline-danger" class="w-100" type="button" @click="deleteJob">Hapus Job</b-button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-lg-6">
                <div id="map-container" class="border border-dark">
                  <GmapMap
                    ref="gmap"
                    :center="mapCenter"
                    :zoom="14"
                    map-type-id="terrain"
                    style="width: 100%; height: 100%"
                  >
                    <GmapMarker
                      :key="index"
                      v-for="(marker, index) in listAddress"
                      :position="{ lat: marker.lat, lng: marker.lng }"
                      :icon="setIconMarker(marker.type)"
                    />
                  </GmapMap>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal alamat pickup-->
    <b-modal title="Tambah Alamat Pickup" ref="modalPickup" id="modal-pickup" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="submitPickupAddress">
        <b-form-group id="address-group" label="Alamat" label-for="address">
          <multiselect v-model="pickup.address" id="searchPickup" 
            label="formatted_address" 
            track-by="place_id" 
            placeholder="Ketik untuk mencari alamat" 
            open-direction="bottom" 
            :options="addresses" 
            :multiple="false" 
            :searchable="true" 
            :loading="isLoadingSearchAddress" 
            :internal-search="false" 
            :clear-on-select="false" 
            :close-on-select="true"
            :max-height="600" 
            :show-no-results="false" 
            :hide-selected="true" 
            @search-change="searchAddress"
            @select="choosePickup"
            :class="{ 'is-invalid': $v.pickup.address.$error }"
          >
            <template slot="noOptions">Alamat tidak ditemukan, coba kata kunci lain</template>
          </multiselect>
          <div v-if="$v.pickup.address.$error" class="invalid-feedback">
            <span v-if="!$v.pickup.address.required">{{ $t('form.validation.required', { field: 'Alamat' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="address-detail-group" label="Detail Alamat" label-for="address-detail">
          <b-form-input
            id="address-detail"
            name="address_detail"
            v-model="pickup.address_detail"
            :class="{ 'is-invalid': $v.pickup.address_detail.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.pickup.address_detail.$error" class="invalid-feedback">
            <span v-if="!$v.pickup.address_detail.required">{{ $t('form.validation.required', { field: 'Detail Alamat' }) }}</span>
          </div> 
        </b-form-group>
        <b-form-group id="name-group" label="Nama" label-for="name">
          <b-form-input
            id="name"
            name="name"
            v-model="pickup.name"
            :class="{ 'is-invalid': $v.pickup.name.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.pickup.name.$error" class="invalid-feedback">
            <span v-if="!$v.pickup.name.required">{{ $t('form.validation.required', { field: 'Nama' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="phone-group" label="Telepon" label-for="phone">
          <b-form-input
            id="phone"
            name="phone"
            v-model="pickup.phone_number"
            :class="{ 'is-invalid': $v.pickup.phone_number.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.pickup.phone_number.$error" class="invalid-feedback">
            <span v-if="!$v.pickup.phone_number.required">{{ $t('form.validation.required', { field: 'Telepon' }) }}</span>
            <span v-if="!$v.pickup.phone_number.minLength">{{ $t('form.validation.min_length', { field: 'Telepon', length: 8 }) }}</span>
            <span v-if="!$v.pickup.phone_number.maxLength">{{ $t('form.validation.max_length', { field: 'Telepon', length: 15 }) }}</span>
          </div>
        </b-form-group>
        <b-button type="submit" variant="success">Simpan</b-button>
        <b-button type="button" variant="secondary" class="ml-2" @click="$refs.modalPickup.hide()">Batal</b-button>
      </b-form>
    </b-modal>

    <!-- modal alamat dropoff-->
    <b-modal title="Tambah Alamat Dropoff" ref="modalDropoff" id="modal-dropoff" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="submitDropoffAddress">
        <b-form-group id="address-group" label="Alamat" label-for="address">
          <multiselect v-model="dropoff.address" id="searchPickup" 
            label="formatted_address" 
            track-by="place_id" 
            placeholder="Ketik untuk mencari alamat" 
            open-direction="bottom" 
            :options="addresses" 
            :multiple="false" 
            :searchable="true" 
            :loading="isLoadingSearchAddress" 
            :internal-search="false" 
            :clear-on-select="false" 
            :close-on-select="true"
            :max-height="600" 
            :show-no-results="false" 
            :hide-selected="true" 
            @search-change="searchAddress"
            @select="chooseDropoff"
            :class="{ 'is-invalid': $v.dropoff.address.$error }"
          >
            <template slot="noOptions">Alamat tidak ditemukan, coba kata kunci lain</template>
          </multiselect>
          <div v-if="$v.dropoff.address.$error" class="invalid-feedback">
            <span v-if="!$v.dropoff.address.required">{{ $t('form.validation.required', { field: 'Alamat' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="address-detail-group" label="Detail Alamat" label-for="address-detail">
          <b-form-input
            id="address-detail"
            name="address_detail"
            v-model="dropoff.address_detail"
            :class="{ 'is-invalid': $v.dropoff.address_detail.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.dropoff.address_detail.$error" class="invalid-feedback">
            <span v-if="!$v.dropoff.address_detail.required">{{ $t('form.validation.required', { field: 'Detail Alamat' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="name-group" label="Nama" label-for="name">
          <b-form-input
            id="name"
            name="name"
            v-model="dropoff.name"
            :class="{ 'is-invalid': $v.dropoff.name.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.dropoff.name.$error" class="invalid-feedback">
            <span v-if="!$v.dropoff.name.required">{{ $t('form.validation.required', { field: 'Nama' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="phone-group" label="Telepon" label-for="phone">
          <b-form-input
            id="phone"
            name="phone"
            v-model="dropoff.phone_number"
            :class="{ 'is-invalid': $v.dropoff.phone_number.$error }"
            type="text"
          ></b-form-input>
          <div v-if="$v.dropoff.phone_number.$error" class="invalid-feedback">
            <span v-if="!$v.dropoff.phone_number.required">{{ $t('form.validation.required', { field: 'Telepon' }) }}</span>
            <span v-if="!$v.dropoff.phone_number.minLength">{{ $t('form.validation.min_length', { field: 'Telepon', length: 8 }) }}</span>
            <span v-if="!$v.dropoff.phone_number.maxLength">{{ $t('form.validation.max_length', { field: 'Telepon', length: 15 }) }}</span>
          </div>
        </b-form-group>
        <b-button type="submit" variant="success">Simpan</b-button>
        <b-button type="button" variant="secondary" class="ml-2" @click="$refs.modalDropoff.hide()">Batal</b-button>
      </b-form>
    </b-modal>
  </Layout>
</template>

<style scoped>
.nav-kiri {
  cursor: pointer;
  position: absolute;
  top: 20%;
  left: 5%;
}
.nav-kanan {
  cursor: pointer;
  position: absolute;
  top: 20%;
  right: 5%;
}

#map-container {
  height: 800px;
}

#list-address {
  border: 2px black solid;
  background-color: aliceblue;
  height: 310px;
  overflow-y: auto;
}

.list-armada {
  height: 300px
}

.armada {
  height: 100%;
  object-fit: cover;
}

.edit:hover {
  background-color: blue;
  color: white;
}
.delete:hover {
  background-color: red;
  color: white;
}
</style>